function repeat(ch: string, len: number) {
  if (len < 1) return '';
  if (len === 1) return ch;
  return new Array(len).join(ch);
}

function obfuscate(str: string, leftOut: number) {
  return repeat('*', str.length - leftOut) + str.slice(-leftOut);
}

export function obfuscateEmail(email: string) {
  const matchParts = email.match(/([^@]+)@(.+)$/);

  // not an email
  if (matchParts === null) {
    return obfuscate(email, 2);
  }

  const [_, emailOwner = '', domain = ''] = matchParts;

  const domains = domain
    .split('.')
    .map(part => obfuscate(part, 2))
    .join('.');

  const obfuscatedEmail =
    emailOwner.length > 8 ? obfuscate(emailOwner, 4) : obfuscate(emailOwner, 2);

  // prevent too long emails  + \u200e is disabling RTL on this string
  return `\u200e${obfuscatedEmail.slice(-12)}@${domains.slice(-10)}`;
}
